import { useRightToLeftStylesheets } from '@/utils/language/rightToLeftStylesheets'

const RIGHT_TO_LEFT_LOCALES = ['ar']

export const isRightToLeftLocale = (locale) => RIGHT_TO_LEFT_LOCALES.includes(locale)

/**
 * Mirrors the whole document for a right-to-left UI locale by setting `dir` and `lang`
 * on <html>; for every other locale both attributes are removed so the page renders
 * exactly as it did before RTL support existed.
 */
export const applyDocumentDirection = (locale, root = document.documentElement) => {
  if (isRightToLeftLocale(locale)) {
    root.setAttribute('dir', 'rtl')
    root.setAttribute('lang', locale)
    useRightToLeftStylesheets()
    return
  }
  root.removeAttribute('dir')
  root.removeAttribute('lang')
}
